export const GET_EMPLOYEE_MEALS = 'GET_EMPLOYEE_MEALS';
export const SET_EMPLOYEE_MEALS = 'SET_EMPLOYEE_MEALS';
export const GET_EMPLOYEE_MEALS_SETTINGS = 'GET_EMPLOYEE_MEALS_SETTINGS';
export const SET_EMPLOYEE_MEALS_SETTINGS = 'SET_EMPLOYEE_MEALS_SETTINGS';
export const UPDATE_EMPLOYEE_MEALS_SETTINGS = 'UPDATE_EMPLOYEE_MEALS_SETTINGS';
export const SET_EMPLOYEE_MEALS_LOCK_DATE = 'SET_EMPLOYEE_MEALS_LOCK_DATE';
export const SAVE_EMPLOYEE_MEAL = 'SAVE_EMPLOYEE_MEAL';
export const SET_EMPLOYEE_MEALS_TOTALS = 'SET_EMPLOYEE_MEALS_TOTALS';
